import { Alert } from 'react-bootstrap';
import { describeExpiryBanner } from '../../utils/credentialState.utils';

/**
 * The expiry banner of ONE class (design read §3.6): 90 and 60 days = info, 30 = warning, 14
 * and 7 = danger, expired = danger with the outage text. Every banner ends with the policy
 * sentence. The banner renders nothing outside the bands.
 *
 * @param {{ tenant: import('types/femaTenant.types').FemaTenantSummary }} props
 */
const CredentialExpiryBanner = ({ tenant }) => {
  const banner = describeExpiryBanner(tenant);
  if (!banner) return null;

  return (
    <Alert variant={banner.variant} className="mb-3" data-testid="fema-credential-expiry-banner">
      <p className="mb-1 fw-semibold">{banner.message}</p>
      <p className="mb-0 small">{banner.policy}</p>
    </Alert>
  );
};

export default CredentialExpiryBanner;
